import { db, get, ref, set } from "./firebaseApi";

function buildActivityId() {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export async function logUserActivity(uid, payload) {
  if (!uid) return;
  const id = buildActivityId();
  await set(ref(db, `Users/${uid}/activities/${id}`), {
    type: payload?.type || "activity",
    title: payload?.title || "Activity",
    details: payload?.details || "",
    createdAt: Date.now(),
  });
}

export async function getRecentUserActivities(uid, limit = 4) {
  if (!uid) return [];
  const snap = await get(ref(db, `Users/${uid}/activities`));
  const data = snap.val() || {};
  return Object.entries(data)
    .map(([id, v]) => ({ id, ...(v || {}) }))
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
    .slice(0, limit);
}

